<div class="filter-row form" *ngIf="filterService.filterConfig.length === filterService.pageFilters.length">
  <!-- filters -->
  <div class="container">
    <app-dynamic-form [fields]="filterService.filterConfig | orderBy:'order'"></app-dynamic-form>
  </div>
</div>